module.exports = __webpack_public_path__ + "img/jch1.c5599fcd.jpg";